import { socketTypes as rawSocketTypes } from '@/constants/sockets/constants';
import { socketTypesFinishing as rawSocketTypesFinishing } from '@/constants/sockets/constants';
import { ImageSetModel } from '@/store/models/Image';

export interface SocketTypeModel {
	name?: string;
	slug: string;
	image_uri: ImageSetModel;
}

export function getSocketImageUri(dataType: string, baseName: string, folder: string) {
	return {
		image_1x: `/img/${dataType}/${folder}/${baseName}.png`,
		image_2x: `/img/${dataType}/${folder}/${baseName}@2x.png`,
		image_3x: `/img/${dataType}/${folder}/${baseName}@3x.png`,
	};
}

export function buildSocketData(
	dataType: string,
	prosthesisCategory: string | undefined,
	types: { slug: string }[],
) {
	if (!prosthesisCategory) return [];

	return types.map(type => ({
		...type,
		image_uri: getSocketImageUri(dataType, type.slug, prosthesisCategory),
	}));
}

export function getSocketTypeBySlug(
	slug: string,
	prosthesisCategory: string | undefined,
	typeSlug: string | undefined,
) {
	const socketTypes = buildSocketData(slug, prosthesisCategory, rawSocketTypes);
	return socketTypes.find(item => item.slug === typeSlug);
}

export function getSocketTypeFinishingBySlug(
	slug: string,
	prosthesisCategory: string | undefined,
	typeSlug: string | undefined,
) {
	const socketTypes = buildSocketData(slug, prosthesisCategory, rawSocketTypesFinishing);
	return socketTypes.find(item => item.slug === typeSlug);
}
